import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, UrlTree, Router } from '@angular/router';
import { Observable } from 'rxjs';
import { map, take } from 'rxjs/operators';
import { CurrentUserService } from '../services/current-user.service';
import { SessionDataService } from '../services/session-data.service';

@Injectable({ providedIn: 'root' })
export class PasswordExpiredGuard implements CanActivate {
  constructor(private currentUserService: CurrentUserService, private router: Router, private sessionDataService: SessionDataService) {}

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean | UrlTree> {
    return this.currentUserService.currentUser.pipe(
      take(1),
      map(result => {
        // If user is not authenticated, redirect to login
        if (!result || !result.currentUser) {
          return this.router.createUrlTree(['/login'], { queryParams: { returnUrl: state.url } });
        }
        
        // If password is not expired, redirect to home
        if (this.sessionDataService.sessionData()?.passwordExpired === false) {
          return this.router.createUrlTree(['/']);
        }

        return true;
      })
    );
  }
}